


export const getQueryStringValue = (nameBeingQueried: string): string | null => {
  const queryString: string = window.location.search.substring(1)
  const variables: string[] = queryString.split("&")

  for (let i = 0; i < variables.length; i++) {
    const variable: string = variables[i];
    const [name, value] = variable.split("=", 2);
    if (name === nameBeingQueried) {
      return value
    }
  }

  return null;
}

export const formatDate = (date: Date | null): string | null => {
  if (!date) return null
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { timeStyle: 'short' })}`
}